import { render, staticRenderFns } from "./AdminSpreadsheetView.vue?vue&type=template&id=0b1b064e"
import script from "./AdminSpreadsheetView.vue?vue&type=script&lang=js"
export * from "./AdminSpreadsheetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports